import { createElement as $$createElement, setStyle as $$setStyle, setDataset as $$setDataset, setEvent as $$setEvent, delegateEvent as $$delegateEvent, setHTMLProp as $$setHTMLProp, setHTMLAttr as $$setHTMLAttr, setHTMLProps as $$setHTMLProps, setHTMLAttrs as $$setHTMLAttrs, createTextNode as $$createTextNode, updateText as $$updateText, insertNode as $$insertNode, ForNode as $$ForNode, CondNode as $$CondNode, ExpNode as $$ExpNode, EnvNode as $$EnvNode, TryNode as $$TryNode, SnippetNode as $$SnippetNode, PropView as $$PropView, render as $$render } from "@dlightjs/dlight";
import { Pretty, View } from "@dlightjs/dlight";

/**
 * @example
 * ```js
 * import { lazy } from "@dlightjs/components"
 * const MyComp = lazy(() => import("./MyComp.view"))
 *
 * import Loading from "./Loading.view"
 * const MyComp = lazy(() => import("./MyComp.view"), Loading)
 * ```
 */
export function lazy<T>(importFunc: () => Promise<{
  default: T;
}>, FallbackCls?: any) {
  class LazyComp extends View {
    constructor() {
      super();
      this.willMount = this.willMount.bind(this);
    }
    _$forwardProps;
    _$forwardPropsSet = new Set();
    _$forwardPropsId = [];
    ViewCls?: any;
    $$ViewCls = 8;
    willMount() {
      void importFunc().then((module: any) => {
        this._$ud(this.ViewCls = module.default, "ViewCls");
      });
    }
    Body() {
      let $node0;
      this._$update = $changed => {
        if ($changed & 8) {
          $node0 && $node0.updateCond();
        }
        $node0 && $node0.update($changed);
      };
      $node0 = new $$CondNode(8, $thisCond => {
        if (this.ViewCls) {
          if ($thisCond.cond === 0) {
            $thisCond.didntChange = true;
            return [];
          }
          $thisCond.cond = 0;
          let $node0, $node1;
          $thisCond.updateFunc = $changed => {
            if ($changed & 8) {
              $node1 && $node1.update(() => $node0, [this.ViewCls]);
            }
            $node0 && $node0.update($changed);
          };
          $node0 = new $$PropView($addUpdate => {
            let $node0;
            $node0 = new this.ViewCls();
            $node0._$init(null, null, null, this);
            return [$node0];
          });
          $node1 = new $$ExpNode($node0, [this.ViewCls]);
          return $thisCond.cond === 0 ? [$node1] : $thisCond.updateCond();
        } else if (FallbackCls) {
          if ($thisCond.cond === 1) {
            $thisCond.didntChange = true;
            return [];
          }
          $thisCond.cond = 1;
          let $node0;
          $thisCond.updateFunc = $changed => {};
          $node0 = new FallbackCls();
          $node0._$init(null, null, null, null);
          return $thisCond.cond === 1 ? [$node0] : $thisCond.updateCond();
        } else {
          if ($thisCond.cond === 2) {
            $thisCond.didntChange = true;
            return [];
          }
          $thisCond.cond = 2;
          $thisCond.updateFunc = $changed => {};
          return $thisCond.cond === 2 ? [] : $thisCond.updateCond();
        }
      });
      return [$node0];
    }
  }
  return ((LazyComp as Pretty) as T);
}